__turbopack_context__.v({
  "className": "bricolage_grotesque_663339c2-module__BIkbNW__className",
});
